import React from 'react'

export const LoadingPage = () => <p>Loading...</p>
